import actions from './loading-page.actions'

export default {
  namespaced: true,
  actions,
}
